import React from "react";
import { Link, useLocation } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_33ee5137-3a8d-4e87-85d8-2bf18f119464/artifacts/go05yinq_solar%20icon%202.png";

export default function BrandHeader({ right = null }) {
  const { pathname } = useLocation();
  const navItems = [
    { to: "/", label: "Quiz", testid: "nav-quiz-link" },
    { to: "/contact", label: "Contact", testid: "nav-contact-link" },
  ];

  return (
    <header
      data-testid="brand-header"
      className="bg-[#001B33] text-white"
      style={{ fontFamily: "Montserrat, sans-serif" }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between gap-4">
        <a
          href="/"
          data-testid="brand-logo-link"
          className="flex items-center gap-3 group min-w-0"
        >
          <img
            src={LOGO_URL}
            alt="Solar Installation Specialists logo"
            className="h-10 w-10 flex-shrink-0 transition-transform group-hover:rotate-12"
          />
          <span className="hidden md:block text-base lg:text-lg font-semibold tracking-wide truncate">
            Solar Installation Specialists
          </span>
          <span className="md:hidden text-sm font-semibold">SIS</span>
        </a>
        <nav
          data-testid="brand-header-nav"
          className="flex items-center gap-1 sm:gap-2"
        >
          {navItems.map((it) => {
            const active = pathname === it.to;
            return (
              <Link
                key={it.to}
                to={it.to}
                data-testid={it.testid}
                className={`px-3 sm:px-4 py-2 rounded-md text-sm font-semibold transition-colors ${
                  active
                    ? "bg-[#FF8800] text-white"
                    : "text-white/80 hover:text-[#FF8800]"
                }`}
              >
                {it.label}
              </Link>
            );
          })}
          {right && <div className="ml-2">{right}</div>}
        </nav>
      </div>
    </header>
  );
}
